import React from 'react';

export const WashingMachineSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 32 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clipRule="evenodd" d="M2 0C0.895431 0 0 0.895431 0 2V3.64512H31.3372V2C31.3372 0.895431 30.4418 0 29.3372 0H2ZM31.3372 4.73828H0V34.0742C0 35.1788 0.895429 36.0742 2 36.0742H29.3372C30.4418 36.0742 31.3372 35.1788 31.3372 34.0742V4.73828ZM15.6685 30.4473C21.3148 30.4473 25.8921 25.87 25.8921 20.2236C25.8921 14.5773 21.3148 10 15.6685 10C10.0221 10 5.44482 14.5773 5.44482 20.2236C5.44482 25.87 10.0221 30.4473 15.6685 30.4473ZM29.3652 8.34835C29.3652 9.18687 28.6854 9.86663 27.8469 9.86663C27.0084 9.86663 26.3286 9.18687 26.3286 8.34835C26.3286 7.50983 27.0084 6.83008 27.8469 6.83008C28.6854 6.83008 29.3652 7.50983 29.3652 8.34835Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 32 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="31.3372" height="36.0742" rx="2" fill="#FFC700" />
      <circle cx="15.6685" cy="22.2241" r="7.48643" fill="white" stroke="#997700" strokeWidth="2.30976" />
      <circle cx="27.8469" cy="9.51828" r="1.51828" fill={window?.settings?.secondary_color ?? '#04333b'} />
      <circle cx="23.5183" cy="9.51828" r="1.51828" fill={window?.settings?.secondary_color ?? '#04333b'} />
      <line y1="4.73828" x2="31.3372" y2="4.73828" stroke="white" strokeWidth="2" />
      <path d="M15.8283 23.0926C12.4772 22.5261 9.62022 23.8332 8.77103 24.525C9.46581 26.5916 12.2721 30.1608 16.6347 29.2752C20.9974 28.3896 22.5409 24.9401 21.9231 21.8549C21.3947 22.4817 19.1794 23.6591 15.8283 23.0926Z" fill="#ACE1FF" />
      <path d="M16.04 24.2844C12.9949 23.2284 10.0131 23.8442 9.06152 24.2843C9.27299 26.1542 11.0916 29.8942 15.4056 29.8942C19.7196 29.8942 21.7497 26.1539 22.0669 24.284C21.4325 24.724 19.0852 25.3405 16.04 24.2844Z" fill="#35AAEC" />
    </svg>
  )
}